import React from 'react';
import { ReadonlyEditor } from '@react-page/editor';
import createCellPlugins from '../plugins/cellPlugins';
import { createTheme, useTheme, ThemeProvider } from '@mui/material/styles';
import EditorLayout from './EditorLayout';
import Head from 'next/head';
const LANGUAGES = [
    {
        lang: 'en',
        label: 'English',
    },
    {
        lang: 'de',
        label: 'Deutsch',
    },
];
const MigeranPageViewer = (props) => {
    const cellPlugins = createCellPlugins(props);
    let value = null;
    let theme = useTheme();
    let custom_theme = undefined;
    if (props.data) {
        if (props.data.page_data) {
            console.log('Page title: ' + props.data.page_data.title);
            if (props.data.page_data.data && props.data.page_data.data !== '') {
                value = JSON.parse(props.data.page_data.data);
            }
        }
        if (props.data.page_layout_data && props.data.page_layout_data.component_name) {
            //TODO Create CustomLayout
        }
        if (props.data.page_layout_data && props.data.page_layout_data.theme) {
            const custom_theme_data = props.data.page_layout_data.theme;
            custom_theme = createTheme({
                palette: {
                    primary: {
                        light: custom_theme_data.palette_primary_light ? custom_theme_data.palette_primary_light : theme.palette.primary.light,
                        main: custom_theme_data.palette_primary_main ? custom_theme_data.palette_primary_main : theme.palette.primary.main,
                        dark: custom_theme_data.palette_primary_dark ? custom_theme_data.palette_primary_dark : theme.palette.primary.dark,
                    },
                    secondary: {
                        light: custom_theme_data.palette_secondary_light ? custom_theme_data.palette_secondary_light : theme.palette.secondary.light,
                        main: custom_theme_data.palette_secondary_main ? custom_theme_data.palette_secondary_main : theme.palette.secondary.main,
                        dark: custom_theme_data.palette_secondary_dark ? custom_theme_data.palette_secondary_dark : theme.palette.secondary.dark,
                    }
                }
            });
        }
    }
    const url = props.data.url;
    let page_id = props.data.page_data.route ? props.data.page_data.route : 'blog';
    if (!page_id.startsWith('/')) {
        page_id = '/' + page_id;
    }
    const image_path = props.data.page_data.image ? props.data.page_data.image : '';
    const image_url = props.data.page_data.image ? `${url}${image_path}` : '';
    const title = props.data.page_data.title ? props.data.page_data.title : '';
    const description = props.data.page_data.description ? props.data.page_data.description : '';
    const editor_theme = custom_theme ? custom_theme : theme;
    return (React.createElement(ThemeProvider, { theme: editor_theme },
        React.createElement(Head, null,
            React.createElement("meta", { property: "og:url", content: `${url}${page_id}` }),
            React.createElement("meta", { property: "og:title", content: title }),
            React.createElement("meta", { property: "og:description", content: description }),
            React.createElement("meta", { property: "og:image", content: image_url })),
        React.createElement(EditorLayout, Object.assign({}, props),
            React.createElement(ReadonlyEditor, { cellPlugins: cellPlugins, value: value, lang: LANGUAGES[0].lang, languages: LANGUAGES, uiTheme: editor_theme, useStorageUrl: true }))));
};
export default MigeranPageViewer;
//# sourceMappingURL=MigeranPageViewer.js.map